export const RESCUE_GIFT_CARD_PRODUCT_ID = 'gift-card-sub-1y';
